import { t } from "ttag";

import { ScreenLayout } from "@/app/components/layouts";
import { SetUpPasswordAlertModal } from "@/app/components/modals";
import { LiveSessionNotificationBar } from "@/features/coaching/components";
import { JourneySupportPromotionModal } from "@/features/coaching/sections";
import { ServerModal } from "@/features/server-modals/components";
import { usePageTitle } from "@/shared/hooks";
import { HomeHeader } from "./sections";
import { HomeContent } from "./sections/content";

export const Home = () => {
  usePageTitle(t`Home`);

  return (
    <>
      <ScreenLayout className="gap-6 md:gap-1">
        <LiveSessionNotificationBar />

        <HomeHeader />

        <HomeContent />
      </ScreenLayout>

      <SetUpPasswordAlertModal />

      <JourneySupportPromotionModal />

      <ServerModal />
    </>
  );
};
